import { parse } from "papaparse";

// @ts-ignore
const convertCsvToObject = (csv) => {
  return parse(csv);
};

export { convertCsvToObject };
